import { render, staticRenderFns } from "./color-block.vue?vue&type=template&id=8d648b02&scoped=true&"
import script from "./color-block.vue?vue&type=script&lang=js&"
export * from "./color-block.vue?vue&type=script&lang=js&"
import style0 from "./color-block.vue?vue&type=style&index=0&id=8d648b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d648b02",
  null
  
)

export default component.exports